customElements.define('cart-total', class CartTotal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  async render() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      let total = 0;

      cart.items.forEach(item => {
        const customPrice = parseFloat(item.properties?._custom_price);
        if (!isNaN(customPrice)) {
            total +=   customPrice * item.quantity;
        } else {
           total +=   item.final_price *item.quantity;
        }
      });
      const dollars = total / 100;
      const formattedTotal = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(dollars);

      this.innerHTML = `<p class="block w-36 text-right">${formattedTotal}</p>`;
    } catch (err) {
      console.error('Error calculating custom total:', err);
      this.innerHTML = `<span style="color:red;">Error loading custom total</span>`;
    }
  }
});
